export function productsQuantity (products) {
  if (!products || !products.length) return 0

  return products.reduce((total, product) => {
    if (!product || !Array.isArray(product.quantityCart)) return total
    return total + product.quantityCart.reduce((sum, qty) => sum + (Number(qty) || 0), 0)
  }, 0)
}

export function recordProductQuantity (record) {
  if (!record) return 0
  if (record.change) return productsQuantity(record.newProducts)
  if (typeof record.quantity === 'number') return record.quantity
  return productsQuantity(record.cart)
}



// WEBPACK FOOTER //
// ./src/helpers/productQuantity.js